import { ZoomUpdateMode } from '../enums/zoomUpdateMode';

export default class ZoomPluginConfiguration {
  apiToken = '';
  updateMode = ZoomUpdateMode.FullSentence;
}
